import React, { useState,useEffect } from "react";
import AOS from "aos";
import "./Service.css";
import { Modal, ModalBody, ModalFooter, Button } from "reactstrap";
import DetailService from "../DetailService/DetailService";
import { Link } from "react-router-dom";
import Services from "./SerServer";
import OpacityLoading from "../Loading/OpacityLoading";
function Service() {
  const [services] = useState(Services);
  const [modalOpen, setmodalOpen] = useState(false);
  const [selectItem, setselectItem] = useState(null);

  const ToggleModal = (item) => {
    setmodalOpen(!modalOpen);
    setselectItem(item);
  };

  let serviceDetail = null;
  if (modalOpen != null) {
    serviceDetail = <DetailService item={selectItem} />;
  }

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  return (
    <>
      <OpacityLoading>
        <div>
          <div>
            <div className="service-hero">
              <h1 data-aos="fade-up">Services</h1>
            </div>
            <div className="short-service-title text-center">
              <h3>What services do I provide !</h3>
              <span>Services/features</span>
              <p>
                Most common methods for designing websites that work well on
                desktop is <br /> responsive and adaptive design
              </p>
            </div>
            <div className="service-item container" data-aos="zoom-in">
              {services.map((item) => {
                return (
                  <div className="sitem" key={item.id}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <div className="content">
                      <Link>
                        <img src={item.image} alt="" />
                      </Link>
                      <Link>
                        {" "}
                        <h2>{item.title} </h2>
                      </Link>
                      <Link>
                        {" "}
                        <p>{item.description.slice(0, 100)}... </p>
                      </Link>
                      <button
                        className="text-center"
                        onClick={() => ToggleModal(item)}
                      >
                        Learn more
                      </button>
                    </div>
                  </div>
                );
              })}

              <Modal className="my-5" isOpen={modalOpen}>
                <div className="card">
                  <ModalBody>{serviceDetail}</ModalBody>
                </div>

                <ModalFooter>
                  <Button onClick={ToggleModal}> Cancel</Button>
                </ModalFooter>
              </Modal>
            </div>
            <div className="container-fluid">
              <div className="my-life my-5">
                <div className="row">
                  <div className="col-lg-8 col-md-12 col-sm-12 col-12 p-3 my-2 childhood" data-aos="fade-right">
                    <h2>How I Will Help You</h2>
                    <p>
                      As a front-end developer, my goal is to help you create
                      visually appealing, user-friendly and responsive websites
                      and web applications. My services include creating and
                      implementing designs, coding and testing, and ensuring
                      that the final product meets your needs and expectations.I
                      specialize in using modern technologies such as HTML, CSS,
                      JavaScript, and frameworks such as React. <br /> I can
                      help you create responsive designs that adapt to any
                      device, ensuring that your website looks great on desktop,
                      tablet, and mobile devices. I will also be responsible for
                      testing the website and resolving any issues that may
                      arise during the development process. I will ensure that
                      the website is compatible with different browsers and
                      devices and that it is accessible to users with
                      disabilities.In summary, as a front-end developer, I will
                      help you create visually appealing, user-friendly and
                      responsive websites and web applications by utilizing
                      modern technologies and frameworks. <br />
                      <br /> I will work closely with you to understand your
                      target audience, their needs and preferences and make sure
                      that the website is designed to meet their expectations. I
                      will also be responsible for testing the website,
                      resolving any issues that may arise during the development
                      process, and providing ongoing maintenance and support.
                    </p>
                  </div>
                  <div className="col-lg-4  p-3  childhood-pic"></div>
                  <div className="col-lg-2 p-3 m-3 web-dev-pic"></div>
                  <div className="col-lg-9 col-md-12 col-sm-12 col-12 p-3  web-dev" data-aos="fade-left">
                    <h2>My Service Experience </h2>
                    <p>
                      My funniest service experience occurred while working at a
                      local restaurant. One evening, a customer ordered a meal
                      and requested that the kitchen "surprise" them with
                      whatever dish the chef felt like making. The chef decided
                      to get creative and make a dish that was a combination of
                      various menu items, including spaghetti, tacos, and sushi. <br /><br />
                      The customer was ecstatic when the dish arrived at the
                      table and declared it to be the best meal they had ever
                      had. They even asked the chef for the recipe so they could
                      try to recreate it at home.Lastly, I was working at a
                      retail store and a customer came in looking for a specific
                      item. I searched high and low, but couldn't find it
                      anywhere in the store. I asked the customer if there was
                      anything else I could help them find and they replied,
                      "No, but can you just dance for me? I'm having a rough day
                      and I could use a little pick-me-up." So, I happily
                      obliged and did a little dance for the customer, who ended
                      up laughing and thanking me for making their day a little
                      better. <br /><br /> These funny experiences remind me that sometimes,
                      going above and beyond for customers can lead to
                      unexpected and enjoyable outcomes.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </OpacityLoading>
    </>
  );
}

export default Service;
